import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import index from "../../api/auth/customers";
import useCustomerStore from "../../stores/useCustomerStore";
import WushSortableTable from "../../components/layout/WushSortableTable";
import { Delete, Edit, Search } from "@mui/icons-material";
import DeleteConfirmation from "../../components/form/DeleteConfirmation";
import { useNavigate } from "react-router-dom";
import destroy from "../../api/auth/customers/destroy";
import WushPopover from "../../components/layout/WushPopover";
import CustomerForm from "../../components/form/customer/CustomerForm";

export default function Customers() {
  const { customers, setCustomers, removeCustomer } = useCustomerStore();

  const navigate = useNavigate();

  useEffect(() => {
    index((response) => {
      setCustomers(response);
    });
  }, []);

  const handleDelete = (customer) => {
    destroy(customer.id, () => {
      removeCustomer(customer);
    });
  };

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">Customers</Typography>
      </Stack>
      <Stack mb={2}>
        <WushPopover
          anchor={
            <Button variant="contained" color="primary">
              Add Customer
            </Button>
          }
        >
          <Stack p={2}>
            <CustomerForm />
          </Stack>
        </WushPopover>
      </Stack>
      <Stack>
        <WushSortableTable
          title="Customers"
          onRowClick={(row) => navigate(`/customers/${row.id}`)}
          headers={[
            {
              key: "id",
              label: "ID"
            },
            {
              key: "full_name",
              label: "Name"
            },
            {
              key: "email",
              label: "Email"
            },
            {
              key: "stripe_customer_id",
              label: "Stripe ID"
            },
            {
              label: "Actions",
              customValue: (row) => (
                <Stack direction="row">
                  <WushPopover
                    anchor={
                      <IconButton>
                        <Edit />
                      </IconButton>
                    }
                  >
                    <Stack
                      p={2}
                    >
                      <CustomerForm customer={row} />
                    </Stack>
                  </WushPopover>
                  <IconButton onClick={() => navigate(`/customers/${row.id}`)}>
                    <Search />
                  </IconButton>
                  {row.deletable && <DeleteConfirmation handleDelete={() => handleDelete(row)}>
                    <IconButton>
                      <Delete />
                    </IconButton>
                  </DeleteConfirmation>}
                </Stack>
              )
            }
          ]}
          data={customers}
        />
      </Stack>
    </Stack>
  );
}